import React, { useEffect } from "react"

const LoginSucces = () => {
  useEffect(() => {
    setTimeout(() => {
      window.close()
    }, 10000)
  }, [])
  return <div>Login succesfull!!! </div>
}

export default LoginSucces
